/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class OrganizationApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `OrganizationModule.forRoot()`
 */
export interface OrganizationApiConfigurationParams {
  rootUrl?: string;
}
